import type { RatioGroupKey } from "@/config/contentProgramUpload";
import { MediaFrame, TileFoot, TileStatus } from "@/components/content-programs/media-tile";
import { submissionStatus } from "@/components/brand/content-programs/submission-status";
import type { ContentSubmissionRow } from "@/services/contentProgram.service";

export type AffiliateSubmissionRow = ContentSubmissionRow & {
  metaAdsCampaignProgram: {
    id: string;
    title: string;
    commissionRate: number;
    brandDetail: {
      companyName: string | null;
      firstName: string;
      lastName: string;
      username: string | null;
    };
  };
};

export function submissionBrandLabel(row: AffiliateSubmissionRow): string {
  const brand = row.metaAdsCampaignProgram.brandDetail;
  return brand.companyName || `${brand.firstName} ${brand.lastName}`.trim() || "Brand";
}

/** One of the affiliate's submissions on the sheet. Opening it shows the facts and actions. */
export function AffiliateSubmissionPortraitTile({
  row,
  ratio,
  onOpen,
}: {
  row: AffiliateSubmissionRow;
  ratio: RatioGroupKey;
  onOpen: (row: AffiliateSubmissionRow) => void;
}) {
  const poster = row.thumbnailUrl || (row.mediaType === "IMAGE" ? row.mediaUrl : null);
  const title = row.title?.trim() || "Untitled";
  const status = submissionStatus(row.status);

  return (
    <button
      type="button"
      onClick={() => onOpen(row)}
      aria-label={`Open ${title}`}
      className="group block w-full rounded-md text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-card"
    >
      <MediaFrame ratio={ratio} poster={poster} isVideo={row.mediaType === "VIDEO"} className="group-hover:ring-foreground/30">
        <TileStatus tone={status.tone} label={status.label} />
        <TileFoot title={title} note={row.metaAdsCampaignProgram.title} />
      </MediaFrame>
    </button>
  );
}
